"use strict";

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundwareEvents = void 0;

require("regenerator-runtime/runtime.js");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PATH = "/listenevents/";
/**
 *
 * Post events to roundware server
 * @export
 * @class RoundwareEvents
 */

var RoundwareEvents = /*#__PURE__*/function () {
  /**
   * Creates an instance of RoundwareEvents.
   * @param {number} sessionId
   * @param {ApiClient} apiClient
   * @memberof RoundwareEvents
   */
  function RoundwareEvents(sessionId, apiClient) {
    _classCallCheck(this, RoundwareEvents);

    _defineProperty(this, "_startedAssets", {});

    this._sessionId = sessionId;
    this._apiClient = apiClient;
  }
  /**
   *
   * When any asset starts playing
   * @param {number} assetId -
   * @param {Date} [startTime = new Date()] (Optional) time when asset started playing, default to current time
   * @return {Promise} Promise of Response
   * @memberof RoundwareEvents
   */


  _createClass(RoundwareEvents, [{
    key: "logAssetStart",
    value: function () {
      var _logAssetStart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(assetId) {
        var _this = this;

        var startTime,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                startTime = _args.length > 1 && _args[1] !== undefined ? _args[1] : new Date();

                this._apiClient.post(PATH, {
                  starttime: startTime,
                  session: this._sessionId,
                  asset: assetId
                }).then(function (_ref) {
                  var id = _ref.id;
                  return _this._startedAssets[assetId] = {
                    startTime: startTime,
                    id: id
                  };
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logAssetStart(_x) {
        return _logAssetStart.apply(this, arguments);
      }

      return logAssetStart;
    }()
    /**
     *
     * Calculates duration in seconds from when started, and sends patch request to givena assetId
     * @param {number} assetId - id of the asset
     * @return {Promise} Promise of Response
     * @memberof RoundwareEvents
     */

  }, {
    key: "logAssetEnd",
    value: function () {
      var _logAssetEnd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(assetId) {
        var startedAsset, duration_in_seconds;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(assetId in this._startedAssets === false)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                startedAsset = this._startedAssets[assetId];
                duration_in_seconds = (new Date().getTime() - startedAsset.startTime.getTime()) / 1000;
                return _context2.abrupt("return", this._apiClient.patch(PATH + startedAsset.id, {
                  duration_in_seconds: duration_in_seconds
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function logAssetEnd(_x2) {
        return _logAssetEnd.apply(this, arguments);
      }

      return logAssetEnd;
    }()
  }]);

  return RoundwareEvents;
}();

exports.RoundwareEvents = RoundwareEvents;